import { Box, BoxProps, Flex, FlexProps } from '@cmpsr/components';

type DashboardLayoutType = {
  children: React.ReactNode;
  containerProps?: BoxProps;
  contentProps?: FlexProps;
};

export default function DashboardLayout({ children, containerProps, contentProps }: DashboardLayoutType) {
  return (
    <Box
      as="section"
      w="full"
      pt={{ base: 5, md: 8, lg: 12 }}
      px={{ base: 5, md: 8, lg: 16, xl: 24, xxl: 32 }}
      pb={{ base: 5, md: 8, lg: 12 }}
      {...containerProps}
    >
      <Flex
        flexDirection="column"
        justifyContent="center"
        alignSelf="center"
        gap={0}
        w="full"
        maxW="1184px"
        mx="auto"
        textAlign="left"
        className="dashboard-layout"
        {...contentProps}
      >
        {children}
      </Flex>
    </Box>
  );
}
